export const SET_STUDENTS = 'setStudents'
export const SET_STUDENT = 'setStudent'
export const SET_PAGINATION = 'setPagination'
